var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade-bottom" } }, [
        _vm.showCookiesBar
          ? _c(
              "div",
              {
                staticClass: "cookies-bar",
                style: { background: _vm.primaryColor },
              },
              [
                _c("div", { staticClass: "message" }, [
                  _c(
                    "p",
                    { style: { color: _vm.secondaryColor } },
                    [
                      _vm._t("message-text", function () {
                        return [
                          _vm._v("By using this website, you agree to our"),
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "link-underline",
                          style: { color: _vm.secondaryColor },
                          attrs: {
                            type: "button",
                            "data-toggle": "modal",
                            "data-target": "#modal-policy",
                          },
                        },
                        [
                          _vm._t("message-button", function () {
                            return [_vm._v("cookies policy")]
                          }),
                        ],
                        2
                      ),
                      _vm._v("."),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      style: { color: _vm.secondaryColor },
                      attrs: { type: "button" },
                      on: { click: _vm.acceptAll },
                    },
                    [
                      _vm._t("message-btn-confirm", function () {
                        return [_vm._v("OK I CONFIRM")]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-underline",
                      style: {
                        color: _vm.secondaryColor,
                        borderColor: _vm.secondaryColor,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.showModal("modal-cookies")
                        },
                      },
                    },
                    [
                      _vm._t("message-btn-change", function () {
                        return [_vm._v("CHANGE SETTINGS")]
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal-cookies",
            tabindex: "-1",
            "aria-labelledby": "modal-cookies-label",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "modal-body-content" }, [
                    _c(
                      "p",
                      { staticClass: "cookies-title" },
                      [
                        _vm._t("settings-title", function () {
                          return [_vm._v("Cookies Settings")]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-accept-decline accept",
                        attrs: { type: "button", disabled: "" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-accept-decline-switch",
                            style: {
                              borderColor: _vm.primaryColor,
                              color: _vm.primaryColor,
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "switch-label switch-label-left" },
                              [_vm._v(_vm._s(_vm.langs.on))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "switch-label switch-label-right",
                              },
                              [_vm._v(_vm._s(_vm.langs.off))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "descr",
                            style: { color: _vm.primaryColor },
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "descr-title" },
                              [
                                _vm._t("necessary-title", function () {
                                  return [
                                    _vm._v(
                                      "Strictly necessary and performance cookies"
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "descr-text" },
                              [
                                _vm._t("necessary-descr", function () {
                                  return [
                                    _vm._v(
                                      "These cookies remember choices you make to improve your experience. This information is not used for advertising on other sites."
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-accept-decline",
                        class: {
                          accept: _vm.cookies.statistics,
                          decline: !_vm.cookies.statistics,
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.cookies.statistics = !_vm.cookies.statistics
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-accept-decline-switch",
                            style: {
                              borderColor: _vm.primaryColor,
                              color: _vm.primaryColor,
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "switch-label switch-label-left" },
                              [_vm._v(_vm._s(_vm.langs.on))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "switch-label switch-label-right",
                              },
                              [_vm._v(_vm._s(_vm.langs.off))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "descr",
                            style: { color: _vm.primaryColor },
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "descr-title" },
                              [_vm._t("statistics-title")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "descr-text" },
                              [_vm._t("statistics-descr")],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-accept-decline",
                        class: {
                          accept: _vm.cookies.marketing,
                          decline: !_vm.cookies.marketing,
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.cookies.marketing = !_vm.cookies.marketing
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-accept-decline-switch",
                            style: {
                              borderColor: _vm.primaryColor,
                              color: _vm.primaryColor,
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "switch-label switch-label-left" },
                              [_vm._v(_vm._s(_vm.langs.on))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "switch-label switch-label-right",
                              },
                              [_vm._v(_vm._s(_vm.langs.off))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "descr",
                            style: { color: _vm.primaryColor },
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "descr-title" },
                              [_vm._t("marketing-title")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "descr-text" },
                              [_vm._t("marketing-descr")],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-save-wrapper" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-save-cookies",
                          style: {
                            background: _vm.primaryColor,
                            color: _vm.secondaryColor,
                          },
                          attrs: { type: "button", "data-bs-dismiss": "modal" },
                          on: {
                            click: function ($event) {
                              return _vm.sendCookiesSelection()
                            },
                          },
                        },
                        [
                          _vm._t("btn-save", function () {
                            return [_vm._v("save & close")]
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal modal-pattern fade",
          attrs: {
            id: "modal-policy",
            tabindex: "-1",
            "aria-labelledby": "modal-cookies-label",
            "aria-hidden": "true",
            "data-bs-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-centered" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "modal-body-content" }, [
                    _c(
                      "p",
                      { staticClass: "cookies-title" },
                      [
                        _vm._t("policy-title", function () {
                          return [_vm._v("Cookies Policy")]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "lh-16" },
                      [
                        _vm._t("policy-descr", function () {
                          return [
                            _c("p", [
                              _vm._v(
                                "We use “cookies” to facilitate the use of our website. Cookies are small text files that are stored by your browser on your device and are necessary for the use of our website. We use cookies to understand better how our website is used and to improve website navigation. The cookies we use do not store personal data or personal information that may lead to identification of the person to whom they relate and which has been collected by other means. If you do not wish us to collect information via cookies, please set up your internet browser to delete all existing cookies from your computer’s hard drive, block all cookies in the future and receive a warning before saving a cookie. More detailed information can be found in your browser's operating settings."
                              ),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-modal-close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("×")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }